"use client";

import React from "react";
import BlueBall from "../../assets/LandingPage/blueBollBackground.png";
import { useNavigate } from "react-router-dom";
import { AiOutlineCheck } from "react-icons/ai";
import { FaPlay } from "react-icons/fa";

export default function TransformProcurement() {
  const navigate = useNavigate();

  return (
    <section className="relative w-full sm:min-h-[730px] flex items-center justify-center sm:justify-start bg-white px-6 pt-16 sm:pt-0 sm:px-10 lg:px-20 mb-16 sm:mb-10 overflow-hidden">
      <div className="absolute inset-0 flex justify-end items-center pointer-events-none">
        <img
          src={BlueBall}
          alt="Blue Ball"
          className="object-contain opacity-90 max-w-[80%] sm:max-w-[60%] lg:max-w-[100%]"
        />
      </div>

      <div className="relative z-10 flex flex-col items-center sm:items-start justify-center sm:justify-start max-w-full sm:max-w-3xl lg:max-w-4xl text-center sm:text-left space-y-10 sm:space-y-10">
        <div className="inline-block border-none sm:border border-[#8EBEF4] py-4 rounded-md w-full">
          <h1 className="text-3xl sm:text-4xl lg:text-5xl font-bold leading-[1.1] sm:leading-tight tracking-[-1px] sm:tracking-[-1.28px] text-[#111827]">
            Ready to Transform
            <br />
            <span className="block mt-2 sm:mt-3">
              Your{" "}
              <span className="text-transparent bg-clip-text bg-gradient-to-r from-[#0088FF] to-[#8EBEF4] font-hanken text-3xl sm:text-4xl lg:text-5xl font-bold leading-none tracking-[-1px] sm:tracking-[-1.28px]">
                Procurement?
              </span>
            </span>
          </h1>
        </div>

        <p className="text-[#1D2739] font-hanken font-normal leading-none tracking-[-1.28px] text-[24px] sm:text-[32px] lg:text-[32px] w-full sm:w-[80%]">
          Join forward-thinking organizations that have already revolutionized
          their supplier management with Source IQ's AI-powered platform.
        </p>

        <div className="flex flex-col sm:flex-row items-start sm:items-center gap-4 mt-8 sm:mt-4 w-full">
          <button
            onClick={() => navigate("/signup")}
            className="w-full sm:w-auto flex flex-row justify-center sm:justify-start items-center gap-2 bg-[#0088FF] text-white px-12 py-4 rounded-xl font-medium transition-all text-sm sm:text-base"
          >
            Get Early Access
            <FaPlay className="ml-2 w-4 h-4" />
          </button>

          <a
            href="mailto:info@sourceiq.com"
            className="border border-gray-400 text-gray-800 text-sm sm:text-base font-medium px-8 sm:px-14 py-3 sm:py-4 rounded-xl hover:bg-gray-50 transition w-full sm:w-auto text-center"
          >
            Schedule Demo
          </a>
        </div>

        <div className="flex flex-col sm:flex-row flex-wrap gap-4 sm:gap-6 mt-6 text-base text-gray-600">
          {[
            "No credit card required",
            "30-day free trial",
            "Setup in 24 hours",
          ].map((feature, index) => (
            <div key={index} className="flex items-center gap-2">
              <AiOutlineCheck className="text-[#0088FF] w-6 h-6 flex-shrink-0" />
              {feature}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
